import type { Editor } from "@tiptap/core";

/**
 * Which editor currently has focus.
 *
 * Module-level rather than React state because the setter is called from a
 * TipTap extension, which has no access to context — and because the window
 * dispatcher reads it on every keystroke and must not re-subscribe to change.
 *
 * Only editors carrying the `shortcutBridge` extension ever register here. The
 * comment and inline-chat boxes build their own restricted extension list and
 * so are never the active editor, which is what stops block-level shortcuts
 * from firing at the page behind a comment someone is typing into.
 */
let activeEditor: Editor | null = null;

export function setActiveEditor(editor: Editor | null): void {
  activeEditor = editor;
}

/**
 * Clear only if `editor` is still the active one. A blur can arrive after the
 * next editor has already focused; an unconditional clear would drop it.
 */
export function clearActiveEditor(editor: Editor): void {
  if (activeEditor === editor) activeEditor = null;
}

export function getActiveEditor(): Editor | null {
  if (activeEditor?.isDestroyed) {
    activeEditor = null;
  }
  return activeEditor;
}
